export default __webpack_public_path__ + "static/10643-5e6747b1c35963452c5fc94fa2007e78.jpg";